import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import WarningIcon from "@mui/icons-material/Error";

import { validarCobranzaJudicial } from "../../features/maestros/cobranzaJudicial/service/serviceCobranzaJudicial";
import { StatusCode } from "../../utils/enums";
import { ValidarCobranzaJudicialDTO } from "../../features/maestros/cobranzaJudicial/models/cobranzaJudicial";

export const CheckMutuo = () => {

    const location = useLocation();
    const { id: idEmergente } = location.state || {}

    const [hasAlert, setHasAlert] = useState<boolean>(false);
    
    const validarAlert = async () => {
        const response = await validarCobranzaJudicial(idEmergente);
        if( response.status === StatusCode.Ok ){
            const resp = response.data as ValidarCobranzaJudicialDTO;
            setHasAlert(resp.cobranzaJudicialIndicator || resp.postergacionDividendoIndicator ? true : false);
        }
    }

    useEffect(() => {
        validarAlert();
    }, [idEmergente]);

    useEffect(() => {
        const handler = (e: Event) => {
            const custom = e as CustomEvent<{ idMutuo?: number }>; 
            // Si envían idMutuo, validar solo si coincide o si no viene id, validar igual
            if (!custom.detail || custom.detail.idMutuo === undefined || custom.detail.idMutuo === idEmergente) {
                validarAlert();
            }
        };
        window.addEventListener('mutuo:estadoActualizado', handler as EventListener);
        return () => window.removeEventListener('mutuo:estadoActualizado', handler as EventListener);
    }, [idEmergente]);

    return (
        <>
            { hasAlert && <WarningIcon color="error" sx={{ marginLeft: "4px", marginBottom: "2px" }} /> }
        </>
    )
}
